/* @flow */
import {
  SET_TIME_RANGE,
  REFRESH_INDICATOR_LIST,
  PAGINATE_INDICATOR_LIST,
  FETCH_INDICATOR_LIBRARY,
  FETCH_INDICATOR_METADATA,
  FETCH_IOC_ENRICHMENT,
  SET_INDICATOR_FETCH_OPTIONS,
  FETCH_INDICATORS_FOR_TAG,
  CLEAR_INDICATORS,
  DELETE_INDICATOR,
  REVERT_CLASSIFICATION,
  EXPORT_INDICATORS_LIST,
  EXPORT_INDICATORS_FOR_TAG,
  STORE_INDICATOR_LOCAL,
} from './action-types.js';

/* Fetch the Indicator List */
export const fetchIndicatorList = (): Object => ({
  type: FETCH_INDICATOR_LIBRARY,
});

export const refreshIndicatorList = (): Object => ({
  type: REFRESH_INDICATOR_LIST,
});

export const storeIndicatorLocally = (indicator: Object | Map<any,any>) => ({
  type: STORE_INDICATOR_LOCAL,
  payload: indicator
});

/* Fetch the next page of the Indicator Library */
export const paginateIndicatorList = (): Object => ({
  type: PAGINATE_INDICATOR_LIST,
});

/* Set specific time range options for the Indicator List */
export const setTimeRange = (): Object => ({
  type: SET_TIME_RANGE,
});

/* Sets fetch options for indicator library pagination */
export const setFetchOptions = (options: Object): Object => ({
  type: SET_INDICATOR_FETCH_OPTIONS,
  payload: options
});

/* Clears the current indicator list */
export const clearIndicatorList = () => ({
  type: CLEAR_INDICATORS,
});

/* Deletes an indicator from the given enclaves */
export const deleteIndicator = (payload: Object): Object => ({
  type: DELETE_INDICATOR,
  payload,
});

/* Fetch existing IOC tags */
export const fetchIndicatorMetadata = (type: string, value: string): Object => ({
  type: FETCH_INDICATOR_METADATA,
  payload: [{ indicatorType: type , value }]
});

export const fetchIndicatorsForTag = (guid: string): Object => ({
  type: FETCH_INDICATORS_FOR_TAG,
  payload: guid,
});

/* Fetch IOC enrichment for selected IOC */
export const fetchEnrichment = (type: string, value: string): Object => ({
  type: FETCH_IOC_ENRICHMENT,
  payload: { type, value }
});

export const revertClassification = (reportId: string, ioc: Map<any, any>): Object => ({
  type: REVERT_CLASSIFICATION,
  payload: { reportId, ioc }
});

/* Export all the indicators in the current list */
export const exportIndicatorList = () => ({
  type: EXPORT_INDICATORS_LIST
});

/* Export list of indicators with a tag */
export const exportIndicatorsForTag = (guid: string) => ({
  type: EXPORT_INDICATORS_FOR_TAG,
  payload: guid,
});



// WEBPACK FOOTER //
// ./src/app/modules/indicators/actions.js